<template lang="pug">

    .ui.grid

        .eight.wide.column(v-if='$slots.default')
            slot

        .right.aligned.column(v-bind:class='{ "sixteen wide": !$slots.default, "eight wide": $slots.default }')

            a.ui.labeled.icon.button(v-on:click='emitCancel()')
                i.remove.icon
                |  {{ cancelLabel }}

            button.ui.labeled.primary.icon.button(
                v-bind:type='saveType'
                v-on:click="emitSave()"
                v-bind:disabled="disabledSaveButton"
            )
                i.checkmark.icon
                |  {{ saveLabel }}
</template>

<script>

    //noinspection ReservedWordAsName,JSUnusedGlobalSymbols
    export default {

        methods: {

            emitCancel() {
                this.$emit('cancel')
            },

            emitSave() {
                this.$emit('save')
            }

        },

        props: {

            cancelLabel: {
                type: String,
                default: 'Abbrechen'
            },

            disabledSaveButton: {
                type: Boolean,
                default: false
            },

            saveLabel: {
                type: String,
                default: 'Speichern'
            },

            saveType: {
                type: String,
                default: 'submit'
            }

        }

    }

</script>
